import { useNavigate } from "react-router-dom";
import { api, getAuth, clearAuth } from "@/lib/api";
import { useVerifiedSession } from "@/lib/useVerifiedSession";
import AdminShell from "@/components/AdminShell";
import { LayoutGrid, Building2, CreditCard, Smartphone, LifeBuoy, HardDrive } from "lucide-react";

const nav = [
  { to: "/super", icon: LayoutGrid, label: "Dashboard", end: true },
  { to: "/super/tenants", icon: Building2, label: "Tenants" },
  { to: "/super/plans", icon: CreditCard, label: "Plans" },
  { to: "/super/mobile-apps", icon: Smartphone, label: "Mobile Apps" },
  { to: "/super/storage", icon: HardDrive, label: "Storage" },
  { to: "/super/support", icon: LifeBuoy, label: "Support" },
].map((n) => ({ ...n, testid: `super-nav-${n.label.toLowerCase()}` }));

export default function SuperLayout() {
  const navigate = useNavigate();
  const { status, retry } = useVerifiedSession(
    async () => {
      const auth = getAuth();
      if (!auth || auth.user.role !== "super_admin") return false;
      return (await api.get("/auth/me")).data.role === "super_admin";
    },
    () => navigate("/super/login", { replace: true }),
    "super",
  );

  const logout = () => { clearAuth(); navigate("/super/login"); };

  return (
    <AdminShell testid="super-layout" overline="LocalAppStore" title="Super Console"
      nav={nav} onLogout={logout} logoutTestid="super-logout" status={status} onRetry={retry} />
  );
}
